import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { OrganizationUserRole } from '../../enums/organization-user-roles.enum';

@Component({
    selector: 'app-role-filter-drop-down',
    templateUrl: './approle-filter-drop-down.component.html',
    styleUrls: ['./approle-filter-drop-down.component.scss'],
})
export class AppRoleFilterDropDownComponent {
    @Input() selectedRoles: OrganizationUserRole[] = [];
    @Output() roleChange = new EventEmitter<OrganizationUserRole[]>();

    openedFlyout = false;
    @Input() rightAlignment: boolean = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    statusOptions = [
        { label: 'APP-ADMIN', value: 'APP_ADMIN' },
        { label: 'APP-USER', value: 'APP_USER' },
    ];
    @Input() singleSelection = false;

    isFilterActive: boolean = this.selectedRoles.length > 0;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedRoles']) {
            this.isFilterActive = this.selectedRoles && this.selectedRoles.length > 0;
        }
    }

    toggleRoleSelection(value: OrganizationUserRole): void {
        if (this.singleSelection) {
            this.selectedRoles = [value];
            this.applyFilter();
            return;
        }

        const isCurrentlySelected = this.selectedRoles.includes(value);
        this.onRoleSelection(value, !isCurrentlySelected);
    }

    onRoleSelection(value: OrganizationUserRole, checked: boolean) {
        if (this.singleSelection) {
            this.selectedRoles = [];
            this.selectedRoles.push(value);
            this.applyFilter();
            return;
        }

        if (checked) {
            this.selectedRoles.push(value);
        } else {
            this.selectedRoles = this.selectedRoles.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;
        if (!buttonElement) return;

        this.openedFlyout = true;

        // Use setTimeout to allow the flyout to be rendered before measuring it
        setTimeout(() => {
            const flyoutElement = document.querySelector('.app-role-flyout-menu-container'); // Ensure this class is on your flyout container
            if (!flyoutElement) {
                this.openedFlyout = false;
                return;
            }

            const buttonRect = buttonElement.getBoundingClientRect();
            const flyoutRect = flyoutElement.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            let top = buttonRect.bottom + 8;
            let left = buttonRect.left;

            // Adjust vertical position if it overflows the bottom
            if (top + flyoutRect.height > viewportHeight) {
                top = buttonRect.top - flyoutRect.height - 8;
            }

            // Prevent from going off-screen at the top
            if (top < 0) {
                top = 8;
            }

            if (this.rightAlignment) {
                // For right alignment, align the right edge of the flyout with the right edge of the button
                left = buttonRect.right - flyoutRect.width;
            }

            // Adjust horizontal position if it overflows on the right
            if (left + flyoutRect.width > viewportWidth) {
                left = viewportWidth - flyoutRect.width - 8;
            }

            // Adjust horizontal position if it overflows on the left
            if (left < 0) {
                left = 8;
            }

            this.flyoutPosition = {
                top: top,
                left: left,
                right: 0, // right is not used, left positioning is sufficient
            };
        }, 0);
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedRoles.length > 0;
        this.closeFlyout();
        this.roleChange.emit(this.selectedRoles);
    }

    clearFilter(): void {
        this.selectedRoles = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.roleChange.emit(this.selectedRoles);
    }
}
